
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  '3-dots-rounded': {
    width: 35,
    height: 35,
    viewBox: '0 0 35 35',
    data: '<path pid="0" d="M17.5 0C27.2 0 35 7.8 35 17.5S27.2 35 17.5 35 0 27.2 0 17.5 7.8 0 17.5 0z" _fill="#fff"/><path pid="1" d="M17.5 35C7.9 35 0 27.1 0 17.5S7.9 0 17.5 0 35 7.9 35 17.5 27.1 35 17.5 35zm0-34C8.4 1 1 8.4 1 17.5S8.4 34 17.5 34 34 26.6 34 17.5 26.6 1 17.5 1z" _fill="#dee4eb"/><circle pid="2" _fill="#2e3640" cx="17.1" cy="13.6" r="1.5"/><circle pid="3" _fill="#2e3640" cx="17.1" cy="18" r="1.5"/><circle pid="4" _fill="#2e3640" cx="17.1" cy="22.4" r="1.5"/>'
  }
})
